export enum ProviderDataKeys {
	AamsSessionId = "aams.AamsSessionId",
	AamsTicketId = "aams.AamsTicketId",
	AamsOnlyFreeSpinAllowed = "aams.OnlyFreeSpinAllowed",
	AamsSessionAmount = "aams.SessionAmount.Amount",
	AamsCurrencyCode = "aams.SessionAmount.CurrencyCode",
	AamsMoneyType = "aams.SessionAmount.MoneyType",
	HistoryUrl = "historyUrl",
	AamsUpdateSessionId = "AamsSessionId",
	AamsUpdateTicketId = "AamsTicketId",
}

export enum MoneyTypes {
	Real = "Real",
	RealBonus = "RealBonus",
	FunBonus = "FunBonus",
}

export enum AdditionalParameters {
	Tab = "Tab",
	EventId = "EventID",
	SubeventId = "SubeventID",
	LiveId = "LiveID",
	Shared = "shared",
	SharedCode = "sharedcode",
}

export interface AamsGameDataContextState {
	activeGame: Record<string, string>;
	isSessionDisplayed: boolean;
	additionalParameters: Record<string, string>;
	path: string;
}
